import React from 'react'

export default ({ className, title }) => (
  <svg width="18px" height="20px" viewBox="0 0 18 20"
    version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink"
  >
    <title>{title}</title>
    <g id="7-9" stroke="none" strokeWidth="1"
      fill="none" fillRule="evenodd"
    >
      <g id="RM---answer-autogen-question" transform="translate(-459.000000, -1199.000000)">
        <g id="file-upload" transform="translate(460.000000, 1200.000000)">
          <ellipse id="Oval" stroke="#56565A" strokeLinecap="round"
            strokeLinejoin="round" cx="11.7748918" cy="14.0064103"
            rx="4.41558442" ry="4.20192308"
          />
          <path d="M11.7748918,16.1073718 L11.7748918,11.9054487" id="Path" stroke="#56565A"
            strokeLinecap="round" strokeLinejoin="round"
          />
          <path d="M11.7748918,11.9054487 L10.1190476,13.4811699" id="Path" stroke="#56565A"
            strokeLinecap="round" strokeLinejoin="round"
          />
          <path d="M11.7748918,11.9054487 L13.4307359,13.4811699" id="Path" stroke="#56565A"
            strokeLinecap="round" strokeLinejoin="round"
          />
          <g id="accounting-document" />
          <path d="M5.24355167,16.4408578 C4.43309365,16.4408578 2.41916133,16.4408578 0.798245286,16.4408578 C0.357386588,16.4408578 0,16.120822 0,15.726038 L0,0.714822553 C0,0.320038489 0.357386588,0 0.798245286,0 L8.45341758,0 C8.66593766,-0.000526782436 8.86992027,0.0748543446 9.02017173,0.209444967 L13.3418717,4.07947927 C13.4915821,4.21350278 13.5757576,4.39529035 13.5757576,4.58485685 C13.5749283,6.23836116 13.5743063,6.76366961 13.5738917,7.59042177" id="Path" stroke="#56565A"
            strokeLinecap="round" strokeLinejoin="round"
          />
          <path d="M8.72727273,0 L8.72727273,3.79416298 C8.72727273,4.22093658 9.09457232,4.56690493 9.54765933,4.56690493 L13.5757576,4.56690493" id="Path" stroke="#56565A"
            strokeLinecap="round" strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
)
